import { render, staticRenderFns } from "./RecurringMessages.vue?vue&type=template&id=1c137d55&scoped=true&"
import script from "./RecurringMessages.vue?vue&type=script&lang=js&"
export * from "./RecurringMessages.vue?vue&type=script&lang=js&"
import style0 from "./RecurringMessages.vue?vue&type=style&index=0&id=1c137d55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c137d55",
  null
  
)

export default component.exports